import React, { useEffect, useContext } from 'react';
import ReactDom from 'react-dom';

import { Context } from '@store/store';

import { StyledShelfModal } from './shelf-modal.styles';

const ShelfModal = () => {
  const [state, dispatch] = useContext(Context);

  useEffect(() => {
    const timer = setTimeout(
      () => dispatch({ type: 'SHOW_SHELF_MODAL', payload: false }),
      2000,
    );
    return () => clearTimeout(timer);
  }, [state.isShelfModalShown]);

  return state.isShelfModalShown
    ? state.isOnShelf
      ? ReactDom.createPortal(
          <StyledShelfModal>
            <svg
              width="18"
              height="14"
              viewBox="0 0 18 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1 5.88916C3.0828 8.27559 6.33333 12 6.33333 12C6.33333 12 12.4286 5.4 17 1"
                stroke="#117E30"
                strokeOpacity="0.5"
                strokeWidth="2"
              />
            </svg>
            Книга добавлена на полку
          </StyledShelfModal>,
          document.getElementById('modal'),
        )
      : ReactDom.createPortal(
          <StyledShelfModal>
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M18.36 19.78L12 13.41L5.63997 19.78L4.21997 18.36L10.59 12L4.21997 5.63997L5.63997 4.21997L12 10.59L18.36 4.22997L19.77 5.63997L13.41 12L19.77 18.36L18.36 19.78Z"
                fill="#979797"
              />
            </svg>
            Книга убрана с полки
          </StyledShelfModal>,
          document.getElementById('modal'),
        )
    : ReactDom.createPortal(null, document.getElementById('modal'));
};

export default ShelfModal;
